import { toBlob } from 'html-to-image';

export async function copyNodeAsPng(node, options = {}) {
  if (!node) {
    throw new Error('Нет элемента для снимка');
  }

  const blob = await toBlob(node, {
    pixelRatio: 2,
    cacheBust: true,
    ...options,
  });

  if (!blob) {
    throw new Error('Не удалось создать изображение');
  }

  if (!navigator.clipboard?.write || !window.ClipboardItem) {
    throw new Error('Буфер обмена недоступен');
  }

  const pngItem = { 'image/png': blob };

  try {
    await navigator.clipboard.write([new ClipboardItem(pngItem)]);
  } catch {
    await navigator.clipboard.write([
      new ClipboardItem({ 'image/png': Promise.resolve(blob) }),
    ]);
  }
}
